type Props = {
  children: string;
};

export const TutorialText = ({ children }: Props) => (
  <p className="text-color-dark-content font-cabin text-tutorial whitespace-pre-line">
    {children}
  </p>
);
